import * as React from 'react'
import { Form, useFormikContext } from 'formik'
import Box from '@mui/material/Box'
import { CancelAppointmentReasonSelect } from './CancelAppointmentReasonSelect'
import { ButtonAction, ButtonActionSave } from './atoms'
import { AppointmentCompleteRequest } from '@user/store/scheduling'

interface Props {
  onClose: () => void
}

export const CancelAppointmentForm: React.FC<Props> = (props: Props) => {
  const { onClose } = props
  const { dirty, isSubmitting, isValid, submitForm } =
    useFormikContext<AppointmentCompleteRequest>()
  return (
    <Form autoComplete="off">
      <Box mt={2}>
        <CancelAppointmentReasonSelect />
      </Box>

      <Box mt={5} display="flex" justifyContent="flex-end">
        <ButtonAction variant="text" onClick={onClose}>
          Cancel
        </ButtonAction>
        <ButtonActionSave
          color="primary"
          disabled={!dirty || isSubmitting || !isValid}
          type="submit"
          variant="contained"
          onClick={submitForm}
        >
          Save
        </ButtonActionSave>
      </Box>
    </Form>
  )
}

CancelAppointmentForm.displayName = 'CancelAppointmenFormForm'
